export default "__VITE_ASSET__CBQL76la__"